import { createSelector } from '@ngrx/store';
import { EmpresaDGI } from './empresas-dgi.model';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import { entityEmpresaDGIAdapter, EntityEmpresaDGIState } from './empresas-dgi.state';

const { selectEntities, selectAll } =
  entityEmpresaDGIAdapter.getSelectors();

export const getError = (state: EntityEmpresaDGIState): any => state.error;

export const getIsLoading = (state: EntityEmpresaDGIState): boolean =>
  state.isLoading;

export const selectEmpresaDGIState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.empresaDGI
);

export const selectAllEmpresaDGI = createSelector(
  selectEmpresaDGIState,
  selectAll
);

export const selectEntitiesEmpresaDGI = createSelector(
  selectEmpresaDGIState,
  selectEntities
);

export const selectEmpresaDGI = createSelector(
  // Retorno la empresa DGI si existe
  selectAllEmpresaDGI,
  (selectedEmpresas: EmpresaDGI[]) => {
    if (selectedEmpresas && selectedEmpresas.length > 0) {
      return selectedEmpresas[0];
    }
    return null;
  }
);

export const selectEmpresaDGIError = createSelector(
  selectEmpresaDGIState,
  getError
);

export const selectEmpresaDGIIsLoading = createSelector(
  selectEmpresaDGIState,
  getIsLoading
);

